import priceSelectionList from '../utils/getPriceSelectionList';
import getTotalsForSetOfTotals from '../utils/getTotalsForSetOfTotals';
import {
  getConsolidationSelectionTotals,
  getConsolidationTotals
} from '../utils/utils';
import { pricingFields } from './fibreInternetFieldNames';

// A hidden field keeps its forced value (the $100 install fee) but isn't offered, so it must not be priced.
const withoutHiddenFields = formFields => {
  const visible = { ...formFields };
  pricingFields.forEach(name => {
    if (visible[name] && visible[name].isVisible === false) {
      visible[name] = { ...visible[name], value: [], options: [] };
    }
  });
  return visible;
};

export const getFibreInternetTotals = (formFields, orderData) => {
  const customerInformationTotals = getTotalsForSetOfTotals(
    pricingFields,
    withoutHiddenFields(formFields),
    orderData
  );
  return customerInformationTotals;
};

export const getFibreInternetConsolidationTotals = fibreInternetData => {
  return getConsolidationTotals(fibreInternetData);
};

export const getFibreInternetPriceSelections = formFields => {
  const selectionsList = priceSelectionList(
    pricingFields,
    withoutHiddenFields(formFields)
  );
  return selectionsList;
};

export const getFibreInternetConsolidationPriceSelections = fibreInternetData => {
  return getConsolidationSelectionTotals(
    fibreInternetData,
    'fibreInternetData'
  );
};
